// extracted by mini-css-extract-plugin
export var button = "_ie-0";
export var donut = "_ie-1";
export var donutFill = "_ie-3";
export var donutTrack = "_ie-2";